import React from 'react'
import { Popover, Space, Tag, Typography } from 'antd'
import { SyncOutlined } from '@ant-design/icons'
import { statusArray } from '../../../../../../shared/utils/appointmentHelpers'
import { useUser } from '../../../../../../context/userContext'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import * as PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const PatientAppointmentsDetails = ({ patientDetails, hideTime }) => {
  const { user } = useUser()
  const { t } = useTranslation()

  return (
    <Space wrap size={1}>
      <Popover
        title={t('dashboardHome.prevAppointment')}
        content={
          patientDetails.prevAppointment ? (
            <Space direction="vertical">
              <Typography.Text strong>
                {t(`calendar.${patientDetails.prevAppointment.status}`)} -{' '}
                <Tag
                  color={
                    JSON.parse(user.company.appointmentTypes)?.find(s => s.enum === patientDetails.prevAppointment.type)?.color
                  }
                >
                  {t(JSON.parse(user.company.appointmentTypes)?.find(s => s.enum === patientDetails.prevAppointment.type)?.name)}
                </Tag>
              </Typography.Text>
              <Typography.Text>{moment(patientDetails.prevAppointment.start).format('ddd lll')}</Typography.Text>
              <Typography.Text type="secondary">{moment(patientDetails.prevAppointment.start).fromNow()}</Typography.Text>
              <Link to={`/logs/appointment/${patientDetails.prevAppointment.id}`}>{t('app.view')}</Link>
            </Space>
          ) : null
        }
      >
        {patientDetails.prevAppointment ? (
          <Tag
            icon={patientDetails.prevAppointment.status === 'INPROGRESS' ? <SyncOutlined spin /> : null}
            color={
              statusArray.find(s => s.name === patientDetails.prevAppointment.status)?.[
                user.company.darkCalendar ? 'dark' : 'color'
              ]
            }
          >
            &#8592; {moment(patientDetails.prevAppointment.start).format('ll')}{' '}
            {hideTime ? null : (
              <Typography.Text type="secondary" strong>
                <small>{`${moment(patientDetails.prevAppointment.start).format('hh:mm A')}`}</small>
              </Typography.Text>
            )}
          </Tag>
        ) : (
          '-'
        )}
      </Popover>
      <Popover
        title={t('dashboardHome.activeAppointment')}
        content={
          patientDetails.activeAppointment ? (
            <Space direction="vertical">
              <Typography.Text strong>
                {t(`calendar.${patientDetails.activeAppointment.status}`)} -{' '}
                <Tag
                  color={
                    JSON.parse(user.company.appointmentTypes)?.find(s => s.enum === patientDetails.activeAppointment.type)?.color
                  }
                >
                  {t(
                    JSON.parse(user.company.appointmentTypes)?.find(s => s.enum === patientDetails.activeAppointment.type)?.name
                  )}
                </Tag>
              </Typography.Text>
              <Typography.Text>{moment(patientDetails.activeAppointment.start).format('ddd lll')}</Typography.Text>
              <Typography.Text type="secondary">{moment(patientDetails.activeAppointment.start).fromNow()}</Typography.Text>
              <Link to={`/logs/appointment/${patientDetails.activeAppointment.id}`}>{t('app.view')}</Link>
            </Space>
          ) : null
        }
      >
        {patientDetails.activeAppointment ? (
          <Tag
            icon={patientDetails.activeAppointment.status === 'INPROGRESS' ? <SyncOutlined spin /> : null}
            color={
              statusArray.find(s => s.name === patientDetails.activeAppointment.status)?.[
                user.company.darkCalendar ? 'dark' : 'color'
              ]
            }
          >
            &#8595; {moment(patientDetails.activeAppointment.start).format('ll')}{' '}
            {hideTime ? null : (
              <Typography.Text type="secondary" strong>
                <small>{`${moment(patientDetails.activeAppointment.start).format('hh:mm A')}`}</small>
              </Typography.Text>
            )}
          </Tag>
        ) : (
          '-'
        )}
      </Popover>
      <Popover
        title={t('dashboardHome.lastAppointment')}
        content={
          patientDetails.lastAppointment ? (
            <Space direction="vertical">
              <Typography.Text strong>
                {t(`calendar.${patientDetails.lastAppointment.status}`)} -{' '}
                <Tag
                  color={
                    JSON.parse(user.company.appointmentTypes)?.find(s => s.enum === patientDetails.lastAppointment.type)?.color
                  }
                >
                  {t(JSON.parse(user.company.appointmentTypes)?.find(s => s.enum === patientDetails.lastAppointment.type)?.name)}
                </Tag>
              </Typography.Text>
              <Typography.Text>{moment(patientDetails.lastAppointment.start).format('ddd lll')}</Typography.Text>
              <Typography.Text type="secondary">{moment(patientDetails.lastAppointment.start).fromNow()}</Typography.Text>
              <Link to={`/logs/appointment/${patientDetails.lastAppointment.id}`}>{t('app.view')}</Link>
            </Space>
          ) : null
        }
      >
        {patientDetails.lastAppointment ? (
          <Tag
            icon={patientDetails.lastAppointment.status === 'INPROGRESS' ? <SyncOutlined spin /> : null}
            color={
              statusArray.find(s => s.name === patientDetails.lastAppointment.status)?.[
                user.company.darkCalendar ? 'dark' : 'color'
              ]
            }
          >
            &#8594; {moment(patientDetails.lastAppointment.start).format('ll')}{' '}
            {hideTime ? null : (
              <Typography.Text type="secondary" strong>
                <small>{`${moment(patientDetails.lastAppointment.start).format('hh:mm A')}`}</small>
              </Typography.Text>
            )}
          </Tag>
        ) : (
          '-'
        )}
      </Popover>
    </Space>
  )
}

PatientAppointmentsDetails.propTypes = {
  patientDetails: PropTypes.any.isRequired
}

export default PatientAppointmentsDetails
